import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ListInDropdownComponent } from '../list-in-dropdown/list-in-dropdown.component';

import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';

@Component({
  selector: 'participants-list',
  templateUrl: './participants-list.component.html',
  standalone: true,
  imports: [SpanTooltipComponent, ListInDropdownComponent]
})

export class ParticipantsListComponent implements OnChanges {
  participantsList:any = {
    id: this.commonUtilsService.createId(),
    name: '',
  };

  constructor(private commonUtilsService: CommonUtilsService) { }

  @Input() participants: any = null;
  @Input() type: string = '';
  @Input() previousAction: string = '';
  @Input() notificated: any = null;
  @ViewChild(ListInDropdownComponent) listInDropdownComponent: ListInDropdownComponent;

  ngOnChanges(): void {
    if(this.participants?.length){
      this.participantsList.participants = this.participants;
      this.participantsList.participantsCount = this.participants.length - 1;
      if(this.type === 'roles' || this.type === 'organizations'){
        this.configureList();
      }
    }
    this.participantsList.name = this.previousAction?this.previousAction:this.participants?.length?this.participants[0]?.fullName:'';
  }

  configureList(){
    this.participants.forEach((participant:any) => {
      participant.fullName = participant.name;
    });
  }

  toggleMenu(e: any){
    e.stopPropagation();
    this.listInDropdownComponent.toggleMenu(e);
  }
}
